<div class="unauthorized-container px-28 my-10 font-sans">
  <div class="max-w-2xl">
    <h1 class="text-2xl font-semibold mb-6">Authentication Successful</h1>
    
    <div *ngIf="isAuthenticated" class="space-y-4">
      <div class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
        <p><strong>✓ Authentication Status:</strong> Successfully Authenticated</p>
      </div>
      
      <p class="text-gray-700">
        You have been successfully authenticated. Click the button below to continue to the product selection page.
      </p>
      
      <button
        (click)="navigateToProductSelection()"
        class="uppercase bg-orange-forbes p-3 font-light text-sm rounded-md text-white hover:bg-orange-600 transition-colors"
      >
        Continue to Product Selection
      </button>
    </div>

    <div *ngIf="!isAuthenticated" class="space-y-4">
      <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
        <p><strong>✗ Authentication Status:</strong> Not Authenticated</p>
      </div>
      
      <p class="text-gray-700">
        Authentication failed or is incomplete. Please try logging in again.
      </p>
      
      <button
        (click)="goToLogin()"
        class="uppercase bg-orange-forbes p-3 font-light text-sm rounded-md text-white hover:bg-orange-600 transition-colors"
      >
        Return to Login
      </button>
    </div>

    <div *ngIf="errorMessage" class="mt-4">
      <div class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
        <p class="error">{{ errorMessage }}</p>
        <button 
          (click)="retryCheck()"
          class="mt-2 bg-yellow-600 text-white px-3 py-1 rounded text-sm hover:bg-yellow-700 transition-colors"
        >
          Retry
        </button>
      </div>
    </div>
  </div>
</div>
